import { render, staticRenderFns } from "./AllIndiaMockTest.vue?vue&type=template&id=13aeabda"
import script from "./AllIndiaMockTest.vue?vue&type=script&lang=js"
export * from "./AllIndiaMockTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports